import { Link } from "react-router-dom";
import { APPLICATION_STATUSES } from "@/lib/constants";
import { MessageSquare } from "lucide-react";

export default function KanbanBoard({ applications, onStatusChange }) {
  const handleDrop = (e, status) => {
    e.preventDefault();
    const id = e.dataTransfer.getData("text/plain");
    const app = applications.find((a) => a.application_id === id);
    if (app && app.status !== status) onStatusChange(id, status);
  };

  return (
    <div data-testid="kanban-board" className="flex gap-3 overflow-x-auto pb-4">
      {APPLICATION_STATUSES.map((col) => {
        const items = applications.filter((a) => a.status === col.value);
        return (
          <div
            key={col.value}
            data-testid={`kanban-col-${col.value}`}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => handleDrop(e, col.value)}
            className="min-w-[240px] w-60 bg-slate-100 rounded-xl p-3 shrink-0"
          >
            <div className="flex items-center justify-between mb-3 px-1">
              <p className="text-sm font-semibold text-brand-navy">{col.label}</p>
              <span className="text-xs bg-white text-slate-500 rounded-full px-2 py-0.5 font-medium">
                {items.length}
              </span>
            </div>
            <div className="space-y-2 min-h-[60px]">
              {items.map((a) => (
                <div
                  key={a.application_id}
                  data-testid={`kanban-card-${a.application_id}`}
                  draggable
                  onDragStart={(e) => e.dataTransfer.setData("text/plain", a.application_id)}
                  className="bg-white rounded-lg border border-slate-200 p-3 cursor-grab active:cursor-grabbing hover:border-brand-turquoise transition-colors"
                >
                  <p className="text-sm font-medium text-brand-navy">{a.candidate_name}</p>
                  <p className="text-xs text-slate-500 mb-2">{a.offer_title}</p>
                  <Link
                    to={`/messages/${a.application_id}`}
                    data-testid={`kanban-message-${a.application_id}`}
                    className="inline-flex items-center gap-1 text-xs text-brand-turquoise hover:underline"
                  >
                    <MessageSquare className="w-3 h-3" />
                    Messages
                  </Link>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
